/** Default label when a value is null/unknown; matches AG Grid set-filter blanks wording. */
export const TRI_STATE_BOOLEAN_BLANKS_LABEL = '(Blanks)';

export interface TriStateBooleanFilterLabels {
  yes: string;
  no: string;
  /** @default TRI_STATE_BOOLEAN_BLANKS_LABEL */
  blanks?: string;
}

/**
 * Normalizes API / grid raw values into true | false | null.
 * Supports booleans, 0 / 1, "0" / "1", and "true" / "false" (case-insensitive trim).
 */
export function normalizeTriStateBoolean(raw: any): boolean | null {
  if (raw === true || raw === false) {
    return raw;
  }
  if (typeof raw === 'string') {
    const s = raw.trim().toLowerCase();
    if (s === '1' || s === 'true') {
      return true;
    }
    if (s === '0' || s === 'false') {
      return false;
    }
    return null;
  }
  if (raw === 1) {
    return true;
  }
  if (raw === 0) {
    return false;
  }
  return null;
}

/** Reads one field from a row and normalizes it as a tri-state boolean. */
export function normalizeTriStateBooleanFromField(
  data: any,
  field: string
): boolean | null {
  return normalizeTriStateBoolean(data?.[field]);
}

/** Formats a raw or normalized value for AG Grid set-filter / valueFormatter lists. */
export function formatTriStateBooleanFilterLabel(
  value: any,
  labels: TriStateBooleanFilterLabels
): string {
  const normalized = normalizeTriStateBoolean(value);
  if (normalized === true) {
    return labels.yes;
  }
  if (normalized === false) {
    return labels.no;
  }
  return labels.blanks ?? TRI_STATE_BOOLEAN_BLANKS_LABEL;
}
